import store from 'state/redux/store'
export default store
